import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail, Phone, ArrowUp, Heart } from 'lucide-react';

const Footer = ({ data }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-dark-surface border-t border-violet-500/20 py-12 relative overflow-hidden">
      {/* Ligne de code en arrière-plan */}
      <div className="absolute bottom-0 left-0 right-0 text-center text-8xl font-mono text-gray-800/20 select-none">
        {"</>"}
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center">
          {/* Prompt style terminal */}
          <div className="font-mono text-sm text-gray-500 mb-6">
            <span className="text-green-400">richard@portfolio</span>:<span className="text-blue-400">~</span>$ ./contact
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center gap-3 mb-8 text-gray-300 font-mono text-sm">
            <div className="flex items-center gap-2">
              <Mail size={16} className="text-violet-400" />
              <a href={`mailto:${data.email}`} className="hover:text-violet-400 transition-colors">
                {data.email}
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={16} className="text-violet-400" />
              <a href={`tel:${data.phone}`} className="hover:text-violet-400 transition-colors">
                {data.phone}
              </a>
            </div>
          </div>

          {/* Social Links */}
          {/* <div className="flex gap-4 mb-8">
            <motion.a
              whileHover={{ scale: 1.2, y: -3 }}
              href="#"
              className="p-3 bg-dark-card rounded-full text-gray-400 hover:text-violet-400 hover:border-violet-500 border border-dark-border transition-all"
            >
              <Github size={18} />
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2, y: -3 }}
              href="#"
              className="p-3 bg-dark-card rounded-full text-gray-400 hover:text-violet-400 hover:border-violet-500 border border-dark-border transition-all"
            >
              <Linkedin size={18} />
            </motion.a>
          </div> */}

          {/* Copyright */}
          <p className="text-gray-500 text-sm font-mono mb-4">
            {data.copyright}
          </p>

          {/* Dans la section "Made with love" */}
        <div className="flex items-center gap-1 text-xs text-gray-600 font-mono mb-6">
        <span>Built with</span>
        <Heart size={12} className="text-green-400 mx-1" />
        <span>using React & Tailwind</span>
        <span className="ml-2 text-green-500">// v2.0 with green accents</span>
        </div>

          {/* Scroll to top */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.1, y: -5 }}
            whileTap={{ scale: 0.9 }}
            className="p-3 bg-violet-600/20 rounded-full text-violet-400 hover:bg-violet-600 hover:text-white transition-all border border-violet-500/30"
          >
            <ArrowUp size={20} />
          </motion.button>

          {/* Ligne de commande */}
          <div className="mt-6 text-xs font-mono text-gray-600">
            <span className="text-gray-500">$</span> echo "Merci de votre visite !"
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;